import React, { useEffect } from "react";
import { useAuth } from "react-uicomp";

import CompWrapper from "../../hoc/compWrapper/CompWrapper.hoc";
import OurTeamPage from "../../ourTeamPage/OurTeamPage";

export const ListOfStaff = () => {
  const { setHeaderTitle } = useAuth();

  useEffect(() => {
    setHeaderTitle("List of Staffs");
  }, [setHeaderTitle]);
  return <OurTeamPage />;
};
